module.exports = __webpack_public_path__ + "static/img/Coronation2.73ec464b.png";